export default __webpack_public_path__ + "static/media/TheWorldBrazil_01.ba24becb.png";